import React, {useCallback, useEffect, useLayoutEffect, useState} from 'react';
import {
  View,
  Platform,
  ScrollView,
  TextStyle,
  Text,
  Image,
  ImageBackground,
} from 'react-native';

import {observer} from 'mobx-react';

import {StyleSheet} from 'react-native';
import {colorPalette, colors} from '../../../core/config/color.config';

import useStores from '../../stores/useStores';
import {
  DrawerActions,
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {
  useGetConsultationDashboard,
  useGetConsultationUnreadCounts,
} from '../../server/react-query/useConsultation';
import {width, height, totalSize} from 'react-native-dimension';

import {
  IconName,
  RNEButton,
  RNEText,
  ShadowedCard,
  SVGIcon,
} from '../../components';
import {
  DoctorDashboardCard,
  HeaderProfileLeft,
  HeaderProfileRight,
} from '../../views';

import DashboardBackgroundImg from '../../../assets/images/Ellipse_350.png';
import {useGetProfessionalProfile} from '../../server/react-query/usePractitioner';
import {fontFamily} from '../../../core/config/font.config';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';

const DoctorLandingScreen = () => {
  const {doctorProfileStore} = useStores();

  const navigation = useNavigation();

  const route = useRoute();

  const {setCanRefresh} = usePullDownRefreshContext();

  const {
    status,
    data: professionalProfile,
    error,
    isFetching,
  } = useGetProfessionalProfile();

  const [unreadRequestCount, setUnreadRequestCount] = useState(0);

  const {
    data: consultationUnreadCountDetails,
    refetch: refechConsultationUnreadCountDetails,
  } = useGetConsultationUnreadCounts();

  const {data, isLoading, refetch} = useGetConsultationDashboard();

  const [statusIcon, setStatusIcon] = useState<IconName>('profile-complete');

  const [iconSize, setIconSize] = useState<number>(
    Platform.OS === 'web' ? 36 : 24,
  );

  const goToConsultationTab = (tabIndex: number) => {
    if (Platform.OS === 'web') {
      navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
        screen: NavigationKey.CONSULTATION_LIST,
        params: {
          tab: tabIndex,
        },
      });
    } else {
      let screen: NavigationKey;

      switch (tabIndex) {
        case 0:
          screen = NavigationKey.CONSULTATION_TAB_ONGOING;
          break;

        case 1:
          screen = NavigationKey.CONSULTATION_TAB_PENDING;
          break;

        case 2:
          screen = NavigationKey.CONSULTATION_TAB_HISTORY;
          break;

        default:
          screen = NavigationKey.CONSULTATION_TAB_ONGOING;
          break;
      }

      navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
        screen: NavigationKey.CONSULTATION_LIST,
        params: {
          screen: screen,
        },
      });
    }
  };

  useLayoutEffect(() => {
    navigation.setOptions(
      Platform.OS === 'web'
        ? {
            headerShown: true,
            title: 'Dashboard',
            ...{
              headerStyle: {
                backgroundColor: colorPalette.purple,
                borderBottomColor: 'transparent',
                height: 72,
              },
              headerTintColor: colorPalette.white,
              headerTitleStyle: {
                fontWeight: 'bold',
                fontFamily: 'Quicksand-Bold',
                fontSize: 16,
                paddingLeft: 40,
              } as TextStyle,
            },
            headerLeft: () => null,
          }
        : {
            headerShown: true,
            ...{
              headerStyle: {
                elevation: 0,
                shadowOpacity: 0,
              },
              headerTitleStyle: {
                fontWeight: 'bold',
                fontFamily: 'Quicksand-Bold',
                fontSize: 16,
              } as TextStyle,
            },
            headerStyle: {
              backgroundColor:
                route.name === NavigationKey.DOCTOR_SCREEN_LANDING
                  ? '#7a81f3'
                  : colorPalette.white,
              borderBottomColor: 'transparent',
              elevation: 0,
              shadowOpacity: 0,
            },
            headerTitleStyle: {
              paddingLeft: 28,
            },
            headerLeft: () => (
              <HeaderProfileLeft
                inProfileScreen={true}
                isLogoContrast={false}
              />
            ),
            headerRight: () => (
              <HeaderProfileRight
                showMessageIcon={false}
                isMenuLight={false}
                onClick={() =>
                  navigation.dispatch(DrawerActions.toggleDrawer())
                }
              />
            ),
            ...{
              title: '',
              headerTintColor: colorPalette.primary,
            },
          },
    );
  }, [navigation]);

  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== 'web') {
        refetch();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      refechConsultationUnreadCountDetails();
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (consultationUnreadCountDetails) {
      var totalUnReadRequestCount =
        parseInt(consultationUnreadCountDetails?.pendingRequestCount) || 0;

      if (unreadRequestCount !== totalUnReadRequestCount) {
        setUnreadRequestCount(totalUnReadRequestCount);
        refetch();
      }
    }
  }, [consultationUnreadCountDetails]);

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  useEffect(()=>{
    console.log(professionalProfile?.photo?.url,'professionalProfile?.photo?.url')
  },[professionalProfile?.photo?.url]);

  return (
    <>
      {Platform.OS === 'web' ? (
        <ScrollView>
          <View style={webStyles.mainContainer}>
            <View>
              <RNEText
                label={`Hi, Doc ${doctorProfileStore.doctorProfile?.humanName.given[0]}!`}
                variant="header"
                weight="bold"
                color="accent"
                align="center"
              />
              <RNEText
                label="Here are your consultations for today:"
                align="center"
                color="blackLight"
                style={customWebTextFont}
              />
            </View>
            <View style={webStyles.consultationCards}>
              <View style={webStyles.cardContainer}>
                <DoctorDashboardCard
                  isLoading={isLoading}
                  count={data?.pending}
                  label="REQUEST"
                  bgColor={colorPalette.white}
                  labelColor="blackLight"
                  countColor="success"
                  loaderColor={colorPalette.success}
                  onPress={() => goToConsultationTab(1)}
                />
              </View>
              <View style={webStyles.cardContainer}>
                <DoctorDashboardCard
                  isLoading={isLoading}
                  count={data?.ongoing}
                  label="ONGOING"
                  bgColor={colorPalette.success}
                  onPress={() => goToConsultationTab(0)}
                />
              </View>
              <View style={webStyles.cardContainer}>
                <DoctorDashboardCard
                  isLoading={isLoading}
                  count={data?.completed}
                  label="COMPLETED"
                  bgColor={colorPalette.purple}
                  onPress={() => goToConsultationTab(2)}
                />
              </View>
            </View>
          </View>
        </ScrollView>
      ) : (
        <ScrollView
          onScroll={handleScroll}

          onLayout={e => {
            setScrollViewHeight(e.nativeEvent.layout.height);
          }}
          onContentSizeChange={(contentWidth, contentHeight) => {
            setContentHeight(contentHeight);
          }}
          contentContainerStyle={{paddingBottom: height(1)}}>
          {/* <View style={styles.dashSectionRoot}> */}
          {/* Header */}
          <ImageBackground
            source={DashboardBackgroundImg}
            style={{
              width: width(100),
              zIndex: 1,
              height: Platform.OS === 'android' ? width(85) : width(87),
            }}>
            <View style={styles.dashSectionHeader}>
              {/* <View style={styles.dashNotificationIcon}>
                </View> */}

              {/* <View style={styles.dashProfileWrapper}> */}
              <View style={styles.photoContainer}>
                {professionalProfile?.photo?.url ? (
                  <ImageBackground
                    source={{
                      uri: professionalProfile?.photo.url,
                    }}
                    style={mobileStyles.photoStyle}
                    imageStyle={mobileStyles.photoContainerStyle}
                  />
                ) : (
                  <View
                    style={[
                      mobileStyles.photoPlaceholder,
                      mobileStyles.photoPlaceholderMobile,
                    ]}>
                    <SVGIcon name="user-white" size={56} />
                  </View>
                )}

                <View style={mobileStyles.statusIndicator}>
                  <SVGIcon name={statusIcon} size={totalSize(3.2)} />
                </View>
              </View>
              {/* </View> */}

              <Text
                style={
                  styles.dashWelcome
                }>{`Hi, Doc ${doctorProfileStore.doctorProfile?.humanName.given[0]}!`}</Text>
              <Text style={styles.dashSubtitle}>
                Here are your consultations for today
              </Text>
            </View>
          </ImageBackground>

          {/* Cards */}
          <View style={styles.dashCardContainer}>
            <View style={mobileStyles.cardsContainer}>
              <View style={mobileStyles.cardWrapper}>
                <ShadowedCard
                  style={{marginBottom: 0}}
                  onPress={() => goToConsultationTab(1)}>
                  <View style={mobileStyles.cardContainer}>
                    <View style={mobileStyles.cardValue}>
                      {!isLoading ? (
                        <RNEText
                          label={
                            data?.pending.toString().padStart(2, '0') || '0'
                          }
                          variant="header"
                          weight="bold"
                          color="success"
                          numberOfLines={1}
                          style={mobileCardLabelStyle}
                        />
                      ) : (
                        <RNEButton
                          height={24}
                          loading={isLoading}
                          type="clear"
                          loadingProps={{
                            color: colorPalette.success,
                          }}
                          buttonStyle={buttonStyle}
                        />
                      )}
                    </View>

                    <View style={mobileStyles.cardLabel}>
                      <RNEText
                        label="REQUEST"
                        variant="subheader"
                        // weight="bold"
                        color="black"
                        style={{
                          fontFamily: 'Quicksand-Bold',
                          fontSize: totalSize(2.3),
                        }}
                      />
                    </View>
                  </View>
                  {consultationUnreadCountDetails &&
                    consultationUnreadCountDetails?.pendingRequestCount !==
                      '0' && (
                      <View
                        style={{
                          position: 'absolute',
                          top: -height(1.5),
                          right: -width(2.5),
                          backgroundColor: colors.red.regular,
                          borderRadius: totalSize(10),
                          width: width(8),
                          height: width(8),
                          justifyContent: 'center',
                          alignItems: 'center',
                          zIndex: 10,
                        }}>
                        <RNEText
                          label={
                            parseInt(
                              consultationUnreadCountDetails?.pendingRequestCount ||
                                '0',
                            ) > 9
                              ? '9+'
                              : consultationUnreadCountDetails?.pendingRequestCount ||
                                '0'
                          }
                          variant="title"
                          weight="bold"
                          color="white"
                          numberOfLines={1}
                          style={{fontSize: totalSize(1.5)}}
                        />
                      </View>
                    )}
                </ShadowedCard>
              </View>
              <View style={mobileStyles.cardWrapper}>
                <ShadowedCard
                  style={{marginBottom: 0}}
                  backgroundColor={colorPalette.success}
                  onPress={() => goToConsultationTab(0)}>
                  <View style={mobileStyles.cardContainer}>
                    <View style={mobileStyles.cardValue}>
                      {!isLoading ? (
                        <RNEText
                          label={
                            data?.ongoing.toString().padStart(2, '0') || '0'
                          }
                          variant="header"
                          weight="bold"
                          color="white"
                          numberOfLines={1}
                          style={mobileCardLabelStyle}
                        />
                      ) : (
                        <RNEButton
                          height={24}
                          loading={isLoading}
                          type="clear"
                          loadingProps={{
                            color: colorPalette.white,
                          }}
                          buttonStyle={buttonStyle}
                        />
                      )}
                    </View>

                    <View style={mobileStyles.cardLabel}>
                      <RNEText
                        label="ONGOING"
                        variant="subheader"
                        // weight="bold"
                        color="white"
                        style={{
                          fontFamily: 'Quicksand-Bold',
                          fontSize: totalSize(2.3),
                        }}
                      />
                    </View>
                  </View>
                </ShadowedCard>
              </View>
              <View style={mobileStyles.cardWrapper}>
                <ShadowedCard
                  style={{marginBottom: 0}}
                  backgroundColor={colorPalette.purple}
                  onPress={() => goToConsultationTab(2)}>
                  <View style={mobileStyles.cardContainer}>
                    <View style={mobileStyles.cardValue}>
                      {!isLoading ? (
                        <RNEText
                          label={
                            data?.completed.toString().padStart(2, '0') || '0'
                          }
                          variant="header"
                          weight="bold"
                          color="white"
                          style={mobileCardLabelStyle}
                        />
                      ) : (
                        <RNEButton
                          height={24}
                          loading={isLoading}
                          type="clear"
                          loadingProps={{
                            color: colorPalette.white,
                          }}
                          buttonStyle={buttonStyle}
                        />
                      )}
                    </View>

                    <View style={mobileStyles.cardLabel}>
                      <RNEText
                        label="COMPLETED"
                        variant="subheader"
                        color="white"
                        style={{
                          fontFamily: 'Quicksand-Bold',
                          fontSize: totalSize(2.3),
                        }}
                      />
                    </View>
                  </View>
                </ShadowedCard>
              </View>
            </View>
          </View>
          {/* </View> */}
        </ScrollView>
      )}
    </>
  );
};

export default observer(DoctorLandingScreen);

const customWebTextFont = {
  fontSize: 20,
  marginTop: 4,
};

const buttonStyle = {
  paddingHorizontal: 0,
};

const webStyles = StyleSheet.create({
  mainContainer: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 100,
  },
  consultationCards: {
    marginTop: 96,
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  cardWrapper: {
    width: 355,
    height: 312,
  },
  cardContainer: {
    marginRight: 32,
    marginBottom: 32,
    flexShrink: 1,
    flexGrow: 0,
    minWidth: 200,
    maxWidth: 250,
    width: '100%',
  },
  cardLabel: {
    marginTop: 8,
  },
});

const mobileCardLabelStyle = {
  fontSize: totalSize(7),
  fontFamily: 'Quicksand-SemiBold',
  // marginTop: height(2),
  marginTop: Platform.OS === 'android' ? height(2) : height(0),
  marginBottom: Platform.OS === 'android' ? -height(2) : -height(1.3),
  marginLeft: totalSize(2),
};

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingVertical: 60,
    paddingHorizontal: 40,
  },
  statusIndicator: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: -height(1),
    right: width(12),
    // backgroundColor: colorPalette.white,
    width: width(5),
    height: width(5),
    borderRadius: 24,
  },
  photoStyle: {
    flex: 1,
    justifyContent: 'center',
    resizeMode: 'cover',
  },
  photoPlaceholder: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoPlaceholderMobile: {
    borderWidth: 1,
    borderColor: colorPalette.white,
    borderRadius: totalSize(15),
  },
  photoContainerStyle: {
    borderRadius: totalSize(15),
    // shadowColor: '#050B5A',
    shadowOffset: {
      width: 5,
      height: 20,
    },
    shadowRadius: 20,
    // elevation: 10,
    // zIndex: 10,
  },
  cardsContainer: {},
  cardWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardContainer: {
    // height: height(3),
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    // marginTop: -height(5),
    marginTop: Platform.OS === 'ios' ? -height(3) : -height(5),
  },
  cardValue: {
    width: width(28),
    marginTop: Platform.OS === 'android' ? height(0) : height(1),
  },
  cardLabel: {
    flex: 1,
    alignItems: 'center',
    // marginTop: height(5),
    marginTop: Platform.OS === 'ios' ? height(2) : height(5),
    marginLeft: width(0),
  },
});

const styles = StyleSheet.create({
  dashSectionRoot: {
    flex: 1,
    backgroundColor: '#fff',
  },
  dashSectionHeader: {
    alignItems: 'center',
    paddingBottom: 60,
    paddingTop: height(7.5),
  },
  dashNotificationIcon: {
    position: 'absolute',
    top: 15,
    right: 15,
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 6,
    zIndex: 1,
  },
  dashProfileWrapper: {
    marginTop: -40,
    backgroundColor: '#fff',
    borderRadius: width(50),
    padding: 5,
    elevation: 5,
  },
  photoContainer: {
    marginTop: -height(6.5),
    borderRadius: width(50),
    position: 'relative',
    width: width(50),
    height: width(50),
    borderWidth: width(0.5),
    borderColor: '#ffffff',
  },
  dashProfileImage: {
    width: width(45),
    height: width(45),
    borderRadius: width(50),
  },
  dashVerifiedBadge: {
    position: 'absolute',
    bottom: 15,
    right: 15,
    backgroundColor: '#3DD598',
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#fff',
  },
  dashWelcome: {
    fontSize: totalSize(3.5),
    fontFamily: 'Quicksand-Bold',
    color: '#fff',
    marginTop: height(2),
  },
  dashSubtitle: {
    fontSize: totalSize(1.5),
    color: '#DFDFDF',
    fontFamily: 'Quicksand-SemiBold',
    marginTop: Platform.OS === 'android' ? height(0) : height(0.5),
  },
  dashCardContainer: {
    zIndex: 1000,
    // marginTop: -height(3.2),
    marginTop: -height(6.5),
    paddingHorizontal: 20,
    paddingLeft: height(5),
    paddingRight: height(5),
  },
  dashCardRequest: {
    backgroundColor: '#fff',
    borderRadius: 15,
    padding: 20,
    alignItems: 'center',
    marginBottom: 16,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dashCardOngoing: {
    backgroundColor: '#3DD5C0',
    borderRadius: 15,
    padding: 20,
    alignItems: 'center',
    marginBottom: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dashCardCompleted: {
    backgroundColor: '#8267E5',
    borderRadius: 15,
    padding: 20,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dashCardCount: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#fff',
    flex: 1,
  },
  dashCardLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#fff',
    flex: 2,
    textAlign: 'right',
  },
});
